module.exports = __webpack_public_path__ + "assets/img/mecha-btn-648c48dd.png";